/**
 * Runtime data-source keys for custom-discipline field behaviors.
 *
 * Most of these are custom behavior-only keys. Sources shared with rendered
 * layouts (`currentValue`, `inputValues`) are also declared on `InjectedData`.
 */
export const CUSTOM_DISCIPLINE_ATHLETE_SOURCE = "athlete";
export const CUSTOM_DISCIPLINE_ATHLETES_SOURCE = "athletes";
export const CUSTOM_DISCIPLINE_CURRENT_VALUE_SOURCE = "currentValue";
export const CUSTOM_DISCIPLINE_SELECTED_ROW_ID_SOURCE = "selectedRowId";
export const CUSTOM_DISCIPLINE_SELECTED_COLUMN_KEY_SOURCE = "selectedColumnKey";
export const CUSTOM_DISCIPLINE_CURRENT_MEET_SOURCE = "currentMeet";
/**
 * Context group for the page/row being evaluated (opened group tab or meet
 * grid row). Distinct from {@link CUSTOM_DISCIPLINE_CURRENT_GROUP_SOURCE}.
 */
export const CUSTOM_DISCIPLINE_GROUP_SOURCE = "group";
/**
 * Meet-selected current group (`meetStore.currentGroup` / competition focus).
 * Distinct from {@link CUSTOM_DISCIPLINE_GROUP_SOURCE}.
 */
export const CUSTOM_DISCIPLINE_CURRENT_GROUP_SOURCE = "currentGroup";
export const CUSTOM_DISCIPLINE_GROUPS_SOURCE = "groups";
export const CUSTOM_DISCIPLINE_RECORDS_SOURCE = "records";
export const CUSTOM_DISCIPLINE_LEVELS_SOURCE = "levels";
export const CUSTOM_DISCIPLINE_AGE_CATEGORIES_SOURCE = "ageCategories";
export const CUSTOM_DISCIPLINE_WEIGHT_CATEGORIES_SOURCE = "weightCategories";
export const CUSTOM_DISCIPLINE_DISCIPLINES_SOURCE = "disciplines";
export const CUSTOM_DISCIPLINE_LEAGUES_SOURCE = "leagues";
export const CUSTOM_DISCIPLINE_ORGANISATIONS_SOURCE = "organisations";
/** Organisation attached to the competition, independently from the connected account. */
export const CUSTOM_DISCIPLINE_ORGANISATION_SOURCE = "organisation";
export const CUSTOM_DISCIPLINE_MODAL_VALUES_SOURCE = "modalValues";
export const CUSTOM_DISCIPLINE_INPUT_VALUES_SOURCE = "inputValues";
/**
 * Current reference-list item under evaluation (`referenceFilterBehavior`
 * graphs only, e.g. one `ageCategories` row while filtering FK options).
 */
export const CUSTOM_DISCIPLINE_REFERENCE_ITEM_SOURCE = "referenceItem";

/** Raw result stream shared with competition display layouts. */
export const CUSTOM_DISCIPLINE_REFEREE_LIGHTS_SOURCE = "refereeLights";

/** Database-backed sport catalogs, kept separate from legacy shared references. */
export const CUSTOM_DISCIPLINE_SPORT_AGE_CATEGORIES_SOURCE =
  "disciplineAgeCategories";
export const CUSTOM_DISCIPLINE_SPORT_WEIGHT_CATEGORIES_SOURCE =
  "disciplineWeightCategories";
